// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"3b377603","525":"26b0cb52","970":"0f07f2a4"}[chunkId] + ".css";
};